import type { Task } from '@nexo/types';
import { Badge } from '@nexo/ui';
import { CalendarDays, Hash, ListChecks, Lock, MessageSquare, Repeat } from 'lucide-react';
import { useTeam } from '../../layouts/TeamContext';
import { formatDueDate } from '../../lib/format';
import { dueTone, recurrenceText } from './taskUtils';

export function DueBadge({ task }: { task: Task }) {
  if (!task.dueDate) return null;
  return (
    <Badge tone={dueTone(task)}>
      <CalendarDays className="size-3" />
      {formatDueDate(task.dueDate)}
    </Badge>
  );
}

export function ChannelBadge({ channelId }: { channelId: string | null }) {
  const { channels } = useTeam();
  const channel = channelId ? channels.find((c) => c.id === channelId) : undefined;
  if (!channel) return null;
  const Icon = channel.kind === 'dm' ? MessageSquare : channel.isPrivate ? Lock : Hash;
  return (
    <Badge>
      <Icon className="size-3" />
      <span className="max-w-28 truncate">
        {channel.kind === 'dm' ? channel.dmPeer?.displayName : channel.name}
      </span>
    </Badge>
  );
}

/** «2/5» checklist progress and the recurring marker. */
export function ChecklistBadges({ task }: { task: Task }) {
  const done = task.checklist.filter((i) => i.done).length;
  return (
    <>
      {task.checklist.length > 0 && (
        <Badge tone={done === task.checklist.length ? 'success' : 'neutral'}>
          <ListChecks className="size-3" />
          {done}/{task.checklist.length}
        </Badge>
      )}
      {task.recurrence && (
        <span title={recurrenceText(task.recurrence)} className="inline-flex text-muted">
          <Repeat className="size-3.5" />
        </span>
      )}
    </>
  );
}
